import React from 'react';
import LoanOfficerCreateForm from '../../components/lopage/LoanOfficerCreateForm';
import LandingPageNav from '../../components/landingpage/LandingPageNav';

const CreateLOPage = () => (
  <>
    <LandingPageNav />
    <LoanOfficerCreateForm />
  </>
);

export default CreateLOPage;
